export default __webpack_public_path__ + "static/media/futureultravioletpigdraft_64bc5eb7d1805067b9a43800575941c9.8b918720.png";